import React from 'react';
import Header from './../../../component/common/AdminHeader';
import CONSTANT from './../../../constant';
import { loginAs } from './../../../actions/AuthAction';
import { onChange, validateForm } from '../../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            employeeNumber: { name: 'employeeNumber', value: '', error: '', isRequired: true },
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;
    }

    render() {
        const { employeeNumber } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Login As</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 offset-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Employee #</label>
                                                        <input
                                                            type="text"
                                                            className={employeeNumber.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            placeholder="Employee number"
                                                            name={employeeNumber.name}
                                                            value={employeeNumber.value}
                                                            onChange={this.onChange}
                                                        />
                                                        <small>* Note: Admin session would be lost once you click on the submit button</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            loginAs({ employeeNumber: this.state.employeeNumber.value }).then((res: any) => {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    this.props.history.push(CONSTANT.component.userFileList.url);
                } else {
                    alert(res.error);
                }
            });
        }
    }
}

export default ComponentName;